// extracted by mini-css-extract-plugin
export default {"main_div":"Header_main_div__h0xqS","logo_img":"Header_logo_img__kiDps","left_nav":"Header_left_nav__a2Aff","right_nav":"Header_right_nav__1mori"};